"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingOverlay = exports.LoadingContainer = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _Loading = _interopRequireDefault(require("../../Loading"));

const LoadingContainer = _styledComponents.default.div`
  position: relative;
`;
exports.LoadingContainer = LoadingContainer;
const Wrapper = _styledComponents.default.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${({
  $opacity
}) => $opacity !== undefined ? `rgba(255, 255, 255, ${$opacity})` : _blocks.palette.pureWhite};
  z-index: 100;
`;

const LoadingOverlay = ({
  opacity
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, {
    $opacity: opacity
  }, /*#__PURE__*/React.createElement(_Loading.default, null));
};

exports.LoadingOverlay = LoadingOverlay;